<template>
  <div>
    <textarea :id="editorId"></textarea>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CkEditor",
  props: {
    value: String,
    editorId: {
      type: String,
      default: () => `editor-${Math.random().toString(36).substr(2, 9)}`
    },
    config: Object
  },
  data() {
    return {
      editorInstance: null,
    };
  },
  computed: {
    ...mapGetters("company", ["getCompanyDetails"]),
  },
  mounted() {
    this.loadEditor();
  },
  beforeDestroy() {
    if (this.editorInstance) {
      this.editorInstance.destroy();
    }
  },
  methods: {
    loadEditor() {
      if (!window.CKEDITOR) {
        const script = document.createElement("script");
        script.src = "/ckeditor/ckeditor.js";
        script.onload = this.initEditor;
        document.head.appendChild(script);
      } else {
        this.initEditor();
      }
    },
    initEditor() {
      const fontType =
        this.config?.font_defaultLabel ||
        this.getCompanyDetails?.default_font_type ||
        "Arial, Verdana, sans-serif";

      const fontSize =
        this.config?.font_defaultSize ||
        this.getCompanyDetails?.default_font_size ||
        "12px";
      this.editorInstance = window.CKEDITOR.replace(this.editorId, {
        ...this.config,versionCheck:false, 
        font_defaultLabel: fontType,   
        fontSize_defaultLabel: fontSize,
        contentsCss: [
          ...(this.config.contentsCss || []),
          `body { font-family: ${fontType}; font-size: ${fontSize}; }`
        ]
      });

      let initialData = this.value || "";

      if (initialData && !/<span[^>]*style=.*font-family/i.test(initialData)) {
        initialData = `<span style="font-family:${fontType}; font-size:${fontSize}">${initialData}</span>`;
      }
      this.editorInstance.setData(initialData);

      this.editorInstance.on("change", () => {
        const data = this.editorInstance.getData();
        this.$emit("input", data);
      });
    }
  },
  watch: {
    value(newVal) {
    if (this.editorInstance && newVal !== this.editorInstance.getData()) {
      this.editorInstance.setData(newVal);
    }
  }
  }
};
</script>
